import { render } from "./DeleteActionPopup.vue?vue&type=template&id=8a1f3498&scoped=true"
import script from "./DeleteActionPopup.vue?vue&type=script&lang=js"
export * from "./DeleteActionPopup.vue?vue&type=script&lang=js"

import "./DeleteActionPopup.vue?vue&type=style&index=0&id=8a1f3498&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a1f3498"]])

export default __exports__